import { useState } from "react";
import { api, formatApiError } from "../lib/api";
import { toast } from "sonner";
import { Sparkles, RefreshCw } from "lucide-react";

export default function AISuggestions() {
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(false);
  const [generatedAt, setGeneratedAt] = useState(null);

  const run = async () => {
    setLoading(true);
    try {
      const r = await api.post("/ai/reorder-suggestions");
      setText(r.data.suggestions);
      setGeneratedAt(r.data.generated_at);
    } catch (err) {
      toast.error(formatApiError(err));
    }
    setLoading(false);
  };

  return (
    <div className="space-y-6" data-testid="ai-root">
      <div className="flex items-end justify-between">
        <div>
          <div className="text-xs uppercase tracking-widest text-amber-500 font-mono-plex mb-2">
            Intelligence
          </div>
          <h1 className="font-display text-4xl font-bold">AI Insights</h1>
          <p className="text-slate-500 text-sm mt-1">
            Reorder recommendations powered by 30-day consumption trends.
          </p>
        </div>
        <button onClick={run} disabled={loading} className="btn-amber rounded-md px-4 py-2 text-sm flex items-center gap-2 disabled:opacity-60" data-testid="ai-run-btn">
          {loading ? <RefreshCw className="w-4 h-4 animate-spin" /> : <Sparkles className="w-4 h-4" />}
          {loading ? "Analyzing…" : text ? "Regenerate" : "Analyze inventory"}
        </button>
      </div>

      <div className="surface-card rounded-xl p-8 min-h-[300px]" data-testid="ai-output">
        {!text && !loading && (
          <div className="text-center text-slate-500 py-16">
            <Sparkles className="w-8 h-8 text-amber-500 mx-auto mb-4" />
            <div className="font-display text-2xl mb-2">Nothing analyzed yet</div>
            <p className="text-sm max-w-sm mx-auto">
              Click "Analyze inventory" and Claude will study your stock and sales to suggest reorders.
            </p>
          </div>
        )}
        {loading && (
          <div className="text-center py-16 text-slate-500">
            <RefreshCw className="w-6 h-6 animate-spin mx-auto mb-3 text-amber-500" />
            <div className="text-sm">Studying your inventory patterns…</div>
          </div>
        )}
        {text && !loading && (
          <>
            {generatedAt && (
              <div className="text-xs text-slate-500 font-mono-plex mb-4">
                Generated {new Date(generatedAt).toLocaleString()}
              </div>
            )}
            <div className="prose prose-invert prose-sm max-w-none whitespace-pre-wrap text-slate-200 font-[Satoshi]">
              {text}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
